
export type ResourcesLoaded = {
    graphics: string[];
    audio: string[];
};